app.factory('mailboxService', function($http, Upload, $timeout) {
    return {
        draft: function(page, params) {
            return $http.get('/mailbox/draft?page=' + page, {
                params: params
            });
        },
        outbox: function(page, params) {
            return $http.get('/mailbox/outbox?page=' + page, {
                params: params
            });
        },
        send: function(page, params) {
            return $http.get('/mailbox/send?page=' + page, {
                params: params
            });
        },
        mailboxqueue: function(page, params) {
            return $http.get('/mailbox/mailboxqueue?page=' + page, {
                params: params
            });
        },
        filter: function() {
            return $http.get('/mailbox/filter');
        },
        create: function(ids) {
            var params = {};
            if (typeof ids != "undefined" && ids != "") {
                params = {
                    params: {
                        receivers: ids
                    }
                };
            }

            return $http.get('/mailbox/create', params);
        },
        store: function(data) {
            return $http.post('/mailbox', data);
        },
        show: function(id) {
            return $http.get('/mailbox/' + id);
        },
        edit: function(id) {
            return $http.get('/mailbox/' + id + '/edit');
        },
        update: function(id, data) {
            return $http.put('/mailbox/' + id, data);
        },
        delete: function(id) {
            return $http.delete('/mailbox/' + id);
        },
        upload: function(data, callbackSuccess, callbackError) {
            Upload.upload({
                url: '/mailbox/upload',
                data: data
            }).then(function(response) {
                $timeout(function() {
                    if (typeof callbackSuccess != "undefined")
                        callbackSuccess();
                });
            }, function(response) {
                if (response.status > 0) {
                    if (typeof callbackError != "undefined")
                        callbackError();
                }
            }, function(evt) {
                //$scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        },
        removeattachment: function(data) {
            return $http.post('/mailbox/removeattachment', data);
        },
        sendagain: function(id) {
            return $http.post('/mailbox/sendagain', {
                id: id
            });
        },
        movefromwaiting: function(id) {
            return $http.post('/mailbox/movefromwaiting', {
                id: id
            });
        },
        adddocumenttosigning: function(id) {
            return $http.get('/mailbox/adddocumenttosigning?id=' + id);
        },
        confirmEpuapSign: function(id){
            return $http.get('/mailbox/confirmepuapsign?id='+id);
        }
    };
});
